
/**
 * Common utilities for sending webhooks
 */

/**
 * Options for sending a webhook
 */
export interface SendWebhookOptions {
  webhookUrl: string;
  payload: any;
  webhookType: string;
  entityId?: string;
  entityType?: string;
}

/**
 * Result of a webhook send operation
 */
export interface WebhookResult {
  success: boolean;
  responseStatus: number;
  responseText: string;
}

/**
 * Send a webhook with the given options
 */
export const sendWebhook = async ({
  webhookUrl,
  payload,
  webhookType,
  entityId,
  entityType
}: SendWebhookOptions): Promise<WebhookResult> => {
  try {
    console.log(`Preparing to send ${webhookType} webhook notification`, { 
      entityId,
      entityType,
      ...payload
    });
    
    console.log(`${webhookType} webhook payload:`, JSON.stringify(payload, null, 2));
    
    const response = await fetch(webhookUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    
    const responseText = await response.text().catch(() => "Could not get response text");
    const responseStatus = response.status;
    
    console.log(`${webhookType} Webhook Response Details:`, {
      status: responseStatus,
      body: responseText,
      ok: response.ok
    });
    
    if (!response.ok) {
      console.error(`${webhookType} webhook failed with status: ${responseStatus}`, responseText);
      return { success: false, responseStatus, responseText };
    }
    
    console.log(`${webhookType} webhook sent successfully with status:`, responseStatus, responseText);
    return { success: true, responseStatus, responseText };
  } catch (error) {
    console.error(`Unexpected error in ${webhookType} webhook service:`, error);
    return { success: false, responseStatus: 0, responseText: String(error) };
  }
};
